import { getSelectedUpgrades } from './utils';
export const buildCabinUpgradePayload = selectedUpgrades => {
  const selectedUpgradesPayload = selectedUpgrades.map(upgrade => {
    const {
      boundIndex,
      segmentIndex,
      upgradeOption
    } = upgrade || {};
    const travelersIds = upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.travelers.map(traveler => traveler === null || traveler === void 0 ? void 0 : traveler.travelerId).filter(id => id !== undefined);
    return {
      segmentIndex,
      boundIndex,
      upgradeOptions: [{
        travelersIds,
        upgradeTypeCode: upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.upgradeTypeCode
      }]
    };
  });
  const sortedSelectedUpgradesPayload = selectedUpgradesPayload.sort((a, b) => {
    if (a.boundIndex === b.boundIndex) {
      return a.segmentIndex - b.segmentIndex;
    }
    return a.boundIndex - b.boundIndex;
  });
  return sortedSelectedUpgradesPayload;
};
export const getGraphQlSelection = (productId, formSection) => _ref => {
  let {
    form,
    state
  } = _ref;
  const selectedUpgrades = getSelectedUpgrades(form, formSection, state);
  if (!selectedUpgrades.length) {
    return null;
  }
  return {
    productId,
    selectionCabinUpgrade: buildCabinUpgradePayload(selectedUpgrades)
  };
};
//# sourceMappingURL=getGraphQlSelection.js.map